import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';

import { SimpleToolbar } from 'rev-shared/htmlEditor/Constants';

import styles from './VideoReview.module.less';

@Component({
	selector: 'video-review-reply-input',
	template: `
		<vb-ui-html-editor
			name="replyEditorText"
			#htmlEditor
			#replyTextModel="ngModel"
			[attr.aria-label]="'Media_Videos_Comments_AddComment' | translate"
			[(ngModel)]="replyText"
			[editorConfig]="{ toolbar: SimpleToolbar, height: 70, resize_enabled: false }"
			(editorLoaded)="onEditorLoaded(htmlEditor)"
			[vbMaxLength]="MaxReplyLength"
		></vb-ui-html-editor>

		<div [ngClass]="styles.replyBtnsWrapper">
			<button
				type="button"
				(click)="onCancelClick()"
				vbBtnSecondary
			>
				{{ 'Cancel' | translate }}
			</button>
			<button
				type="button"
				class="margin-left"
				[disabled]="replyTextModel.invalid"
				vbBtnPrimary
				(click)="onReplySubmit()"
			>
				<span>{{ 'Post' | translate }}</span>
			</button>
		</div>

		<div *ngIf="replyTextModel.invalid" role="alert" vbUiErrorMessage>
			<div *ngIf="replyTextModel.errors.vbMaxLength">{{ 'ReplyExceedsMaxLength' | translate : { '0' : MaxReplyLength } }}</div>
		</div>
	`
})
export class VideoReviewReplyInputComponent {
	@Output() public replySubmitted = new EventEmitter<string>();
	@Output() public hideReplyInput = new EventEmitter<void>();
	@ViewChild('replyTextModel') public commentTextNgModel: NgModel;

	public readonly styles = styles;
	public readonly SimpleToolbar = SimpleToolbar;
	public readonly MaxReplyLength = 250;

	public replyText: string = '';

	public onReplySubmit(): void {
		if (!this.replyText) { return; }

		this.replySubmitted.emit(this.replyText);
		this.resetModel();
	}

	public onCancelClick(): void {
		this.hideReplyInput.emit();
	}

	public onEditorLoaded(htmlEditor): void {
		setTimeout(() => {
			htmlEditor.editorComponent.editorElement.focus();
		}, 100);
	}

	private resetModel(): void {
		this.replyText = '';
		this.hideReplyInput.emit();
	}

}
